export const justifyContentValues: Record<string, string> = {
  start: "flex-start", end: "flex-end", center: "center",
  between: "space-between", around: "space-around", evenly: "space-evenly",
  stretch: "stretch", normal: "normal",
};

export const alignItemsValues: Record<string, string> = {
  start: "flex-start", end: "flex-end", center: "center",
  baseline: "baseline", stretch: "stretch",
};

export const alignSelfValues: Record<string, string> = {
  auto: "auto", start: "flex-start", end: "flex-end",
  center: "center", stretch: "stretch", baseline: "baseline",
};

export const alignContentValues: Record<string, string> = {
  start: "flex-start", end: "flex-end", center: "center",
  between: "space-between", around: "space-around",
  evenly: "space-evenly", stretch: "stretch", normal: "normal",
};

export const flexDirectionValues: Record<string, string> = {
  row: "row", "row-reverse": "row-reverse",
  col: "column", "col-reverse": "column-reverse",
};

export const flexWrapValues: Record<string, string> = {
  wrap: "wrap", nowrap: "nowrap", "wrap-reverse": "wrap-reverse",
};

export const flexValues: Record<string, string> = {
  "1": "1 1 0%", auto: "1 1 auto", initial: "0 1 auto", none: "none",
};

export const orderValues: Record<string, string> = {
  first: "-9999", last: "9999", none: "0",
  "1": "1", "2": "2", "3": "3", "4": "4", "5": "5",
  "6": "6", "7": "7", "8": "8", "9": "9", "10": "10",
  "11": "11", "12": "12",
};

export const flexBasisValues: Record<string, string> = {
  "0": "0px", auto: "auto", full: "100%",
  "1/2": "50%", "1/3": "33.333%", "2/3": "66.667%",
  "1/4": "25%", "3/4": "75%", "1/5": "20%", "2/5": "40%",
  "3/5": "60%", "4/5": "80%",
};
